import styled from "styled-components";

export const Container = styled.div`
position: relative;
  margin-top: 0rem;
  padding-bottom: 2rem;

  .curve {
    position: absolute; /* Fazendo com que o SVG se alinhe melhor ao fundo */
    bottom: -1px; /* Ajustando o espaçamento inferior */
    width: 100%;
    height: auto;
  }

    .yellow {
    color: yellow;
    background-color: transparent;
}
`

export const FlexOne = styled.div`

max-width: 400px;
 h1 {
    color: #ff9300;
    text-align: center;
    margin-bottom: 2rem;
 }

 p {
    text-align: center;
    font-size: 21px;
 }
 .negrito {
    font-weight: bold;
 }

 .colorido {
    color: #ff9300;
            font-weight: bold;
 }
`

export const FlexTwo = styled.div`


    img {
        width: 100%;
        max-width: 500px;
    }
`

export const CardsContainer = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   background-color: white;
   background-image: url("/images/grid.jpg");
   font-family: 'Sora', sans-serif;
   padding: 1rem 1rem 2rem 1rem;

   h1 {
      text-align: center;
      margin-bottom: 2rem;
      font-size: 20pt;
      color: #0E0F1D;
      max-width: 728px;
   }
`

export const ModulosContainer = styled.div`
   padding: 1rem 0 2rem 0;
   margin-bottom: -3.5rem;
   background-color: #181818;
   overflow-x: hidden;

   h1 {
      font-size: 27px;
      font-family: "Cinzel", serif;
      font-weight: 600;
      margin-bottom: 0rem;
      background: linear-gradient(90deg, #C0C0C0, #D3D3D3, #E8E8E8, #FFFFFF);
        background-clip: text; /* Apenas o texto usa o fundo */
        -webkit-background-clip: text; /* Para compatibilidade com Webkit */
        -webkit-text-fill-color: transparent; /* Torna o fundo visível */
   }

   .provasContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2rem;
      flex-wrap: wrap;
      padding-bottom: 1rem;

      @media (min-width: 900px) {
        gap: 9rem;
    }
   }

   .flexSpace {
      display: flex;
      align-items: center;
      justify-content: space-around;
   }

   h1 {
      color: #ffffff;
      text-align: center;
      padding: 0 1rem !important;
   }

   .titlePerfils {
      padding: 0 1rem;
      max-width: 400px;

      @media (max-width: 995px) {
         margin-top: -2rem;
          margin-bottom: -1rem;
   }
   }

   .titleProva {
      max-width: 400px;
      padding: 0 1rem;
  

   }

   .carrosselContainer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

     

      @media (min-width: 995px) {
        height: 700px;
    }
   }

   .carrosselContainer2 {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
  

      @media (min-width: 995px) {
        height: 710px;
    }

 
   }

   .titleCenter {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 995px) {
         margin-top: -0.5rem;
          margin-bottom: 1.6rem;
   }
   }
`

export const CopyContainer = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   background-color: white;
   background-image: url("/images/grid.jpg");
   font-family: 'Sora', sans-serif;
   padding: 1rem 1rem 2rem 1rem;


   img {
      width: 100%;
      max-width: 500px;
   }

   h1 {
      text-align: center;
      color: #0E0F1D;
   }

   h2 {
      color: green;
      text-align: center;
      font-weight: 600;
   }

   h3 {
      max-width: 450px;
      text-align: center;
      color: #0E0F1D;
      font-weight: 900;
   }

   h4 {
      color: red;
      font-weight: 300;
      font-size: 9pt;

      span {
         color: black;
      }
   }
`

export const Bonus = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
   flex-direction: column;
	padding: 0 1rem 0rem 1rem;
   background-color: black;

   h1 {
      font-size: 27px;
      font-family: "Cinzel", serif;
      font-weight: 600;
      margin-bottom: 0rem;
      background: linear-gradient(90deg, #C0C0C0, #D3D3D3, #E8E8E8, #FFFFFF);
        background-clip: text; /* Apenas o texto usa o fundo */
        -webkit-background-clip: text; /* Para compatibilidade com Webkit */
        -webkit-text-fill-color: transparent; /* Torna o fundo visível */
        padding: 2rem 0;
   }
`

export const Oferta = styled.div`
  display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   background-color: black;
   padding: 1rem 1rem 4rem 1rem;

   .imagePadding {
   padding: 0 1.5rem;
  }

   h1 {
      color: white;
      margin-bottom: 3rem;
      text-align: center;
   }
   
`
export const imageContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
  border-radius: 18px;
  max-width: 500px;
  border: 2px solid orange;
  outline: 2px solid orange;
  outline-offset: 5px;
  box-shadow: 0px 0px 20px 5px orange; /* inset adicionado aqui */

   
   div {
      margin-bottom: 3rem;
      cursor: pointer;
   }

  img {
    max-width: 500px;
    width: 100%;
    border-radius: 18px;
    margin-bottom: 1.1rem;

  }

  .button {
   display: none;
  }
`
export const Garantia = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 1rem 1rem 2rem 1rem;
   

   h4 {
      font-size: 19pt;
      max-width: 728px;
      text-align: center;
      margin-bottom: 0.5rem;
      font-weight: 900;
   }

   h5 {
      margin-bottom: 1rem;
      font-size: 15pt;
      color: green;
      font-weight: 800;
      text-align: center;
   }

   p {
         max-width: 470px;
         font-size: 17pt;
         text-align: center;
      }

      strong {
         font-weight: 900;
      }

      img {
         max-width: 250px;
         margin-bottom: 1rem;
      }
`

export const Copy = styled.div`
   background-color: #000000;
   color: white;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   padding-bottom: 1rem;

   h1 {
      margin-bottom: 1.5rem;
      text-align: center;
      font-size: 27px;
      font-family: "Cinzel", serif;
      font-weight: 600;
      background: linear-gradient(90deg, #C0C0C0, #D3D3D3, #E8E8E8, #FFFFFF);
        background-size: 100% 100%; /* Garantir que o fundo não se espalhe muito */
        background-clip: text; /* Apenas o texto usa o fundo */
        -webkit-background-clip: text; /* Para compatibilidade com Webkit */
        -webkit-text-fill-color: transparent; /* Torna o fundo visível */
   }

   .teste {
      max-width: 700px;
      padding: 0 1rem;
   }

   .CopyContainer {
      gap: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: left;
      margin-top: 1rem;
      background-color: #292926;
      padding: 20px 20px;
      border-radius: 15px;
      width: 100%;

      .icon {
         font-size: 30pt;
      }

      .conteudo {
      font-size: 17pt;
      }
   }
`

export const Versiculo = styled.div`
   background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0rem  1rem 1rem 1rem;
  
  img {
   width: 300px;
   margin-top: -3rem;
   max-width: 500px;
  }

  strong {
   font-weight: 900;
  }

  
  h1 {
      padding: 0 3rem;
      margin-top: 1.5rem;
      text-align: center;
      font-size: 27px;
      font-family: "Cinzel", serif;
      font-weight: 600;
      background: linear-gradient(90deg, #C0C0C0, #D3D3D3, #E8E8E8, #FFFFFF);
        background-size: 100% 100%; /* Garantir que o fundo não se espalhe muito */
        background-clip: text; /* Apenas o texto usa o fundo */
        -webkit-background-clip: text; /* Para compatibilidade com Webkit */
        -webkit-text-fill-color: transparent; /* Torna o fundo visível */
        z-index: 1;
  }

  .audiolivro {
   font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    font-size: 16px;
    margin-top: -3rem;
  }

  p {
    color: white;
    font-family: "Cinzel", serif;
    font-size: 18px;
    max-width: 500px;
    text-align: center;
    font-weight: 500;
    margin: 0; /* Removendo margem inferior do parágrafo */
  }
`;

export const Audio = styled.div`
   background-color: black;
   color: white;
   display: flex;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   font-family: "Cinzel", serif;
   padding-top: 2rem;

   .vermelho {
        background: linear-gradient(90deg, #FF2905, #D83D1F, #C0392B, #9B1B1B);
        background-size: 200% 100%; 
        background-clip: text; 
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

   img {
      width: 100%;
      max-width: 728px;
   }

   h1 {
      text-align: center;
      margin-bottom: -0.5rem;
      padding: 0 1rem !important;
      font-size: 27px;
      margin-top: 1.5rem;
      color: white;
   }

   p {
      text-align: center;
      max-width: 500px;
      font-size: 14pt;
      padding: 0 1rem 0rem 1rem;
     
   }

   .tituloParagrafo {
      font-weight: 600;
      font-size: 20px;
   }

   strong {
      color: #f6dd86;
   }


`

export const SellBoxContainer = styled.div`
   display: flex;
	justify-content: center;
	flex-direction: center;
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
   background-color: #000000;
	padding: 0rem 1rem 0 1rem;

   .sellBox {
      display: flex;
  align-items: center;
  flex-direction: column;
  width: 400px;
  margin: 2rem 0 3rem 0;
  padding: 0rem 0rem 2rem 0rem;
  background: linear-gradient(black, black) padding-box, /* Fundo interno */
            linear-gradient(90deg, #FF2905, #D83D1F, #C0392B, #9B1B1B);
   background-size: 200% 100%; 
  border: 2px solid transparent; /* Necessário para exibir o degradê */
  border-radius: 15px; /* Arredondamento da borda */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Sombra */

  .headline {
   color: white;
   width: 100%;
   max-width: 350px;
   height: 70px;
   margin-top: 0;
   font-size: 18px;
   padding-top: 17px;
   font-weight: 300;
   letter-spacing: 2px;
  }

  .paddingButton {
   padding: 0 1rem;
  }

  .ebook {
	width: 70%;
}

.logoSell {
	width: 70%;
	border-bottom: 1px solid #7a7a7a50;
	padding-bottom: 1rem;
   margin-bottom: 1rem;
}
}

.sellBox h1 {
	color: #ffffff;
	text-transform: uppercase;
	text-align: center;
	font-size: 16pt;
	margin-top: 1rem;
}

.sellBox span {
	color: #ffffff;
	font-weight: 400;

}

.sellBox .desconto {
	font-family: 'Poppins', sans-serif;
	color: #BFBFBF;
	text-align: center;
	font-size: 15pt;
	text-decoration: line-through;
   text-decoration-thickness: 2px; /* Aumenta a espessura da linha */
   font-weight: 900;
}

.precoantigo {
   color: #BFBFBF;
   font-size: 15pt;
   margin-bottom: 0.5rem;
}

.sellBox .preco {
	font-family: 'Poppins', sans-serif;
	text-align: center;
	font-size: 24.5pt;
	padding: 0 1rem;
	font-weight: 700;
   color: white;
}

.sellBox button {
	margin-top: 2rem;
	cursor: pointer;
}

.ebook {
	width: 85%;
}

.descontoimg {
   width: 250px;
   margin-bottom: 2rem;
   margin-top: 0.5rem;
}

.logoSell {
	width: 85%;
	border-bottom: 1px solid #7a7a7a50;
	padding-bottom: 1rem;
   padding-top: 1.3rem;
}

.pgto {
        margin-top: -0.5rem;
        width: 100px;
    }

    a {
      text-align: center;
      padding: 0 1rem;
   
    }

`

export const VslContainer = styled.div`
   display: flex;
   flex-direction: column;
   gap: 2rem;

   background-color: #101010;
      h1 {
         color: WHITE;
         text-align: center;
         padding: 0 1rem !important;
         font-size: 27px;
}

img {
   max-width: 500px;
   width: 100%;
   align-self: center;
   justify-self: center;
   margin-bottom:  3rem;
   padding: 0 1rem;
}
`

export const Beneficios = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: left;
   margin-bottom: 1rem;
   border-top: 1px solid #434040;
   width: 80%;
   padding: 1.5rem 0rem;
   text-align: left;
   gap: 0.5rem;

   p {
      color: white;
   }

   h2 {
      text-align: center;
      color: white;
      font-size: 20px;
      margin-bottom: 1rem;
   }
`

export const CopyHeadline = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0rem  1rem 0rem 1rem;
 margin: 2rem 0;
 background: linear-gradient(90deg, #FF2905, #D83D1F, #C0392B, #9B1B1B);
        background-size: 200% 100%; 
        background-clip: text; 
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
 

  p {
    color: white;
    font-family: "Cinzel", serif;
    font-size: 18px;
    max-width: 500px;
    text-align: center;
    font-weight: 700;
    margin: 0; /* Removendo margem inferior do parágrafo */
  }
`